import { CellProps } from 'react-table';

import { TrackableFile } from 'types/trackables';

import { useModal } from 'hooks/useModal';
import { useDeleteTrackableFiles } from '../../hooks/useDeleteTrackableFiles';

import {
  ContextMenu,
  ContextMenuAction,
} from 'components/ContextMenu/ContextMenu';
import { IconButton } from 'components/IconButton/IconButtonDeprecated';

export type TrackableItemFilesActionsCellProps = CellProps<TrackableFile> & {
  trackableListId: string;
  trackableItemId: string;
  onEdit?: (trackableFile: TrackableFile) => void;
};

export function TrackableItemFilesActionsCell({
  row,
  trackableListId,
  trackableItemId,
  onEdit,
}: TrackableItemFilesActionsCellProps) {
  const trackableFile = row.original;

  const { open } = useModal();
  const { mutateAsync: deleteTrackableFiles } = useDeleteTrackableFiles();

  function handleEditClick() {
    onEdit?.(trackableFile);
  }

  function handleDeleteClick() {
    open('confirm-delete', {
      title: `Are you sure you want to delete ${trackableFile.name}?`,
      onConfirm: () => deleteTrackableFiles({
        trackable_list_id: trackableListId,
        trackable_item_id: trackableItemId,
        trackable_file_ids: [trackableFile.id],
      }),
    });
  }

  return (
    <ContextMenu
      trigger={
        <IconButton
          icon="more-vertical"
          label="Reveal more actions"
          variant="ghost"
        />
      }
    >
      <ContextMenuAction onClick={handleEditClick} icon="edit">
        Edit
      </ContextMenuAction>
      <ContextMenuAction onClick={handleDeleteClick} icon="delete">
        Delete
      </ContextMenuAction>
    </ContextMenu>
  );
}
